import template from './vacationsAbsencesDelegations.html';
import controller from './vacationsAbsencesDelegations.controller';
import './vacationsAbsencesDelegations.scss';

let vacationsAbsencesDelegationsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default vacationsAbsencesDelegationsComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/vacationsAbsencesDelegations/vacationsAbsencesDelegations.component.js